import React__default from 'react';
import styles from './PartnershipCode.module.esm.js';
import labelStyles from './PartnershipLabels.module.esm.js';

var PartnershipLabels = function (_a) {
    var isInMiniCart = _a.isInMiniCart, onRemoveCode = _a.onRemoveCode, partnerships = _a.partnerships;
    return (React__default.createElement("div", { className: labelStyles.partnerships, "data-testid": "applied-partnerships-list" }, partnerships === null || partnerships === void 0 ? void 0 : partnerships.map(function (partnership) { return (React__default.createElement("div", { className: labelStyles.appliedPartnership, "data-testid": "applied-partnership-".concat(partnership.value), key: "".concat(partnership.value) },
        React__default.createElement("span", { className: labelStyles.associatedText },
            "This order is associated with ",
            partnership.label),
        !isInMiniCart && (React__default.createElement("button", { className: styles.partnershipBtn, onClick: onRemoveCode && (function () { return onRemoveCode(partnership.value); }) }, "remove")))); })));
};

export { PartnershipLabels };
//# sourceMappingURL=PartnershipLabels.esm.js.map
